import { HelpContent } from '../../../UI-Lib/Help-Tooltip';

export const INVOICE_DETAILS_HELP: HelpContent[] = [
    {
        helpContentId: 'invoice-details.parcelAcctNum',
        tooltipText: 'Parcel Account Number',
    },
    {
        helpContentId: 'invoice-details.revision',
        tooltipText: 'Assessment Description',
    },
    {
        helpContentId: 'invoice-details.taxableValue',
        tooltipText: 'Value Type',
    },
    {
        helpContentId: 'invoice-details.marketValue',
        tooltipText: 'Market Value',
    },
    {
        helpContentId: 'invoice-details.cap',
        tooltipText: 'Cap Market Value',
    },
    {
        helpContentId: 'invoice-details.exemptionMV',
        tooltipText: 'Exemptions Market Value',
    },
    {
        helpContentId: 'invoice-details.taxableMarketValue',
        tooltipText: 'Taxable Market Value',
    },
    {
        helpContentId: 'invoice-details.taxableAV',
        tooltipText: 'Taxable Assessed Value',
    },
    {
        helpContentId: 'invoice-details.baseRate',
        tooltipText: 'Base Rate',
    },
    {
        helpContentId: 'invoice-details.rate',
        tooltipText: 'Rate',
    },
    {
        helpContentId: 'invoice-details.taxes',
        tooltipText: 'Taxes',
    },
];
